var map = {
	"./1.png": 1491,
	"./10.png": 1492,
	"./2.png": 1493,
	"./3.png": 1494,
	"./4.png": 1495,
	"./5.png": 1496,
	"./6.png": 1497,
	"./7.png": 1498,
	"./8.png": 1499,
	"./9.png": 1500,
	"./answer.png": 803,
	"./background1.png": 802,
	"./background2.png": 801,
	"./background3.png": 800,
	"./background4.png": 799,
	"./ch1.png": 804,
	"./che1.png": 492,
	"./che2.png": 794,
	"./che3.png": 797,
	"./che4.png": 792,
	"./che5.png": 795,
	"./che6.png": 798,
	"./che7.png": 793,
	"./che8.png": 796,
	"./che9.png": 1501,
	"./complete.png": 791
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 493;